import { ImageWithText } from '@quicktools/shared-components/components/landingPages/ImageWithText';
import ImageWithTextScrollable from '@quicktools/shared-components/components/landingPages/ImageWithTextScrollable';
import { IMG_WITH_TEXT_SIZES } from '@quicktools/shared-components/components/landingPages/constants';
import { SingleToolSimilar } from '@quicktools/shared-components/components/common/SingleToolSimilar';
import { memo } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import {
  MARKETING_SLOGAN_TOOL,
  AD_COPY_GENERATOR_TOOL,
  SOCIAL_MEDIA_BIO_TOOL,
  FONT_GENERATOR_TOOL,
  ToolCategory,
} from '@quicktools/shared-components/data';

import analytics from '../../../services/analytics';

import useStyles from './styles';

const SIMILAR_TOOLS = [SOCIAL_MEDIA_BIO_TOOL, AD_COPY_GENERATOR_TOOL, MARKETING_SLOGAN_TOOL];

function StaticSection() {
  const { t } = useTranslation();
  const classes = useStyles();

  const scrollable = [0, 1, 2, 3, 4, 5].map((i) => ({
    title: t(`static.TextArt.scrollable.items.${i}.title`),
    description: (
      <Trans
        i18nKey={`static.TextArt.scrollable.items.${i}.description`}
        components={{ br: <br /> }}
      />
    ),
    alt: t(`static.TextArt.scrollable.items.${i}.alt`),
    src: t(`static.TextArt.scrollable.items.${i}.src`),
  }));

  return (
    <div className={classes.root}>
      <ImageWithText
        alt={t('static.TextArt.imageWithText.alt')}
        title={
          <Trans i18nKey="static.TextArt.imageWithText.title" components={{ strong: <strong /> }} />
        }
        description={
          <Trans
            i18nKey="static.TextArt.imageWithText.description"
            components={{ span: <span />, a: <a /> }}
          />
        }
        src="https://pastatic.picsart.com/cms-pastatic/8de4a622-818c-4ba5-93c5-65bf94e93415.png"
        srcSet="https://pastatic.picsart.com/cms-pastatic/8a9a7855-0faa-4ea2-a3f3-6d11870cd162.png 327w,https://pastatic.picsart.com/cms-pastatic/8de4a622-818c-4ba5-93c5-65bf94e93415.png 648w"
        sizes={IMG_WITH_TEXT_SIZES}
      />
      <ImageWithTextScrollable
        title={<Trans i18nKey="static.TextArt.scrollable.title" components={{ b: <b /> }} />}
        items={scrollable}
      />
      <SingleToolSimilar
        current={FONT_GENERATOR_TOOL}
        analytics={analytics}
        similar={SIMILAR_TOOLS}
        paragraph={t('similarTxt')}
        category={ToolCategory.Text}
      />
    </div>
  );
}

export default memo(StaticSection);
